import { getParameters, formatDate } from '../../helpers/helpers';
import { TRANSACTION_ELEMENTS } from './tv-types';
import { DASHBOARD_CONTAINER, PAGE_LOADER } from '../../types/types';
import { showToast } from '../toasts';

import { getIndividualTransactions } from '../../routes/get-individual-transaction';

/**
 * Gets individual transaction data and calls a function to display it.
 * 
 * @returns void
 */
export const viewTransaction = async () => {
  if( !TRANSACTION_ELEMENTS.tHeader ) return;

  let transactionID: string = getParameters('transactionID');

  const { body } = await getIndividualTransactions(transactionID);

  if ( !body ) {
    showToast('aafp_toast-alert', 'No transaction data found');
    return;
  }

  displayTransaction(body[0]);
}

type transaction = {
  accountNumber: string,
  askedFor: string,
  authCode: string,
  cardGroupName: string,
  cardName: string,
  cardNumber: string,
  customerId: string,
  customerName: string,
  deliveredGallons: string,
  driverNumber: string,
  hoseId: string,
  paidDollars: string,
  partnerId: string,
  partnerName: string,
  paymentMethod: string,
  paymentReference: string,
  priceCalculation: string,
  pricePerGallonCents: string,
  result: string,
  retry: string,
  terminalId: string,
  terminalName: string,
  timeStampReq: string,
  totalizer: string,
  training: string,
  trainingComplete: string,
  txnId: string
}

/**
 * Displays an individual transaction
 * 
 * @param {object} data the api response body
 */
const displayTransaction = (data: object) => {

  const { 
    accountNumber, 
    partnerId, 
    cardName, 
    cardNumber, 
    cardGroupName,
    driverNumber,
    partnerName, 
    paymentMethod, 
    paymentReference, 
    paidDollars, 
    customerName, 
    deliveredGallons,
    timeStampReq,
    training,
    trainingComplete,
    terminalId,
    terminalName,
    hoseId
  } = data as transaction;

  TRANSACTION_ELEMENTS.tHeader.innerText = `Viewing transaction made on ${formatDate(timeStampReq)}`;  
  TRANSACTION_ELEMENTS.tCustomerName.innerText = customerName;  
  TRANSACTION_ELEMENTS.tPartnerName.innerText = partnerName;

  let paymentType = paymentMethod === '1' ? 'Invoice' : 'Pay at Pump';
  if ( paymentMethod === '1') {
    TRANSACTION_ELEMENTS.tWidget.style.display = 'none';    
  }

  TRANSACTION_ELEMENTS.tPaidDollars.innerText = `$${paidDollars}`;
  TRANSACTION_ELEMENTS.tPaymentMethod.innerText = paymentType;
  TRANSACTION_ELEMENTS.tPaymentReference.innerText = paymentReference != '' ? paymentReference : '--';
  
  TRANSACTION_ELEMENTS.tCardName.innerText = cardName;
  TRANSACTION_ELEMENTS.tCardNumber.innerText = cardNumber;
  TRANSACTION_ELEMENTS.tCardGroupName.innerText = cardGroupName;
  //TRANSACTION_ELEMENTS.tTraining.innerText = training === '0' ? 'Not required' : 'Required';
  TRANSACTION_ELEMENTS.tTrainingComplete.innerText = trainingComplete === '0' ? 'Training not viewed' : 'Training viewed';
  TRANSACTION_ELEMENTS.tTerminalId.innerText = terminalId;
  TRANSACTION_ELEMENTS.tTerminalName.innerText = terminalName;
  TRANSACTION_ELEMENTS.tHose.innerText = hoseId === '0' ? 'Autogas/Bottle Fill' : hoseId === '1' ? 'Autogas' : 'Bottle Fill';
  TRANSACTION_ELEMENTS.tGallons.innerText = deliveredGallons;

  PAGE_LOADER.loaderContainer.classList.add('aafp_no-show');
  DASHBOARD_CONTAINER.removeAttribute('style');
}